import type { AgentPlanAnalyticsAttributes } from '@atlaskit/rovo-agent-analytics/actions/groups/create-flow';
import type { StudioCreateAgentPlan } from '@atlassian/conversation-assistant-message-actions-api/studio';

export const getPlanAnalyticsAttributes = (
	plan: StudioCreateAgentPlan,
): AgentPlanAnalyticsAttributes => {
	const baseTools = plan.tools?.filter((t) => t.definitionSource !== 'MCP_SERVER') ?? [];
	const baseMcpServers = plan.tools?.filter((t) => t.definitionSource === 'MCP_SERVER') ?? [];
	const agentToolsList: string = baseTools
		.map((t) => t.definitionId)
		.filter(Boolean)
		.sort()
		.join(', ');

	const agentKnowledge: AgentPlanAnalyticsAttributes['agentKnowledge'] =
		plan.knowledgeSources?.sources?.reduce(
			(acc, src) => {
				acc[src.source] = { enabled: !!src.enabled, filters: '' };
				return acc;
			},
			{} as NonNullable<AgentPlanAnalyticsAttributes['agentKnowledge']>,
		) ?? null;

	const scenarioList =
		plan.scenarios?.map((scenario): AgentPlanAnalyticsAttributes['scenarioList'][number] => {
			const scenarioTools = (scenario.tools ?? []).filter(
				(t) => t.definitionSource !== 'MCP_SERVER',
			);
			const scenarioMcpServers = (scenario.tools ?? []).filter(
				(t) => t.definitionSource === 'MCP_SERVER',
			);
			const scenarioToolIds = scenarioTools.map((t) => t.definitionId).filter(Boolean) as string[];

			const scenarioKnowledge: string[] | null =
				scenario.knowledgeSources?.sources?.map(({ source }) => source) ?? null;

			const knowledgeType: 'custom' | 'disabled' | 'all' = scenario.knowledgeSources?.enabled
				? scenarioKnowledge && scenarioKnowledge.length > 0
					? 'custom'
					: 'disabled'
				: 'all';

			return {
				toolCount: scenarioTools.length,
				toolsList: [...scenarioToolIds].sort().join(', '),
				mcpServerCount: scenarioMcpServers.length,
				knowledgeType,
				knowledge: scenarioKnowledge,

				/** plans do not yet support skills */
				skillCount: 0,
				skillsList: '',
			};
		}) ?? [];

	return {
		agentToolCount: baseTools.length,
		agentToolsList,
		agentMcpServerCount: baseMcpServers.length,
		agentKnowledge,
		scenarioList,
		agentSkillCount: 0,
		agentSkillsList: '',
		agentType: plan.agentType as 'AgentStudioAssistant',
	};
};
